import { NewNames as NewNamesForm } from "@bgea-js/form-templates";
import donationHeaderHCBO from "../../../../src/content/hidden-christmas/donationHeader";
import "../../../../src/content/hidden-christmas/hidden-christmas.scss";
import * as React from 'react';
export default {
  NewNamesForm,
  donationHeaderHCBO,
  React
};